// App startup (session check -> profile -> first screen) is owned by `app.vue` alone. Pages that
// used to run their own copy of it — `pages/index.vue` checked the session and loaded the profile
// again, in parallel, then navigated on its own schedule — wait for it here instead. That second
// copy raced `app.vue`: the splash hid when `app.vue` finished, while `index.vue`'s navigation to
// `/dashboard` was still loading that page, so the login screen flashed for a moment in between.

let resolveStartup: () => void = () => {}
const startupDone = new Promise<void>((resolve) => {
  resolveStartup = resolve
})

/** Called by `app.vue` once startup is over — signed in (and on the first screen) or not. */
export function markAppStartupDone() {
  resolveStartup()
}

/** Resolves once `app.vue` has finished startup; already resolved afterwards. */
export function waitForAppStartup(): Promise<void> {
  return startupDone
}
